<template>
  <b-card no-body>
    <PageLoading v-if="isLoading" />
    <b-card-body v-else id="customers-card-body">
      <div class="d-flex justify-content-end w-full align-items-center mb-2">
        <v-select
          id="provider_type"
          class="mr-1"
          :clearable="false"
          style="width: 300px"
          v-model="providerType"
          :options="
            providers.map(i => {
              return {
                text: i.name,
                value: i.id
              };
            })
          "
          @change="loadItems($event)"
          :placeholder="t('Select Provider Type')"
          label="text"
          :tabindex="2"
        >
          <span slot="no-options">{{ t('No records found') }}</span>
        </v-select>
        <v-select
          id="provider_package_type"
          class="mr-1"
          :clearable="false"
          style="width: 300px"
          v-model="packagingType"
          :options="
            packagingTypes.map(i => {
              return {
                text: i.info,
                value: i.value
              };
            })
          "
          @change="loadItems($event)"
          :placeholder="t('Select Provider Package Type')"
          label="text"
          :tabindex="2"
        >
          <span slot="no-options">{{ t('No records found') }}</span>
        </v-select>
        <v-select
          v-if="!packagingType || packagingType.value !== 3"
          id="package_type"
          class="mr-1"
          :clearable="false"
          style="width: 200px"
          v-model="packageType"
          :options="
            packageTypes.map(i => {
              return {
                text: i.info,
                value: i.value
              };
            })
          "
          @change="loadItems($event)"
          :placeholder="t('Select Package Type')"
          label="text"
          :tabindex="2"
        >
          <span slot="no-options">{{ t('No records found') }}</span>
        </v-select>
        <b-button variant="primary" type="button" size="sm" @click="createPricing()">
          <feather-icon icon="PlusIcon" size="15" />
          <span>{{ t('Add New Pricing') }}</span>
        </b-button>
      </div>

      <region-pricing-table-view v-if="rows" :data="rows" />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BButton } from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { helper } from '@core/mixins/helper.js';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import useService from '@/auth/service/useService';
import store from '@/store/index';
import vSelect from 'vue-select';
import PageLoading from '@core/components/PageLoading.vue';
import RegionPricingTableView from '../providers/RegionPricingTableView.vue';

export default {
  components: {
    BCard,
    BCardBody,
    BButton,
    vSelect,
    PageLoading,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    RegionPricingTableView
  },

  mixins: [helper],

  data() {
    return {
      isLoading: false,
      rows: null,
      packageTypes: [],
      packagingTypes: [],
      providers: [],
      packageType: '',
      packagingType: '',
      providerType: null
    };
  },

  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    }
  },

  async created() {
    try {
      this.isLoading = true;
      this.providers = await useService.getAllProviders({ limit: 100, page: 1 }).then(res => {
        return res.data;
      });

      if (this.providers) {
        this.providerType = {
          text: this.providers[0].name,
          value: this.providers[0].id
        };
      }

      this.packagingTypes = await useService.constantService
        .getProviderRegionPricePackageType()
        .then(res => {
          return res.data;
        });

      if (this.packagingTypes) {
        this.packagingType = {
          text: this.packagingTypes[0].info,
          value: this.packagingTypes[0].value
        };
      }
    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    async loadItems() {
      if (this.providerType) this.isLoading = true;

      useService.customerService
        .getCustomerPricingByPackageType({
          customerId: this.$route.params.id,
          providerId: this.providerType.value,
          packageType: this.packagingType.value,
          packageValue: this.packageType?.value || this.packageType.value
        })
        .then(response => {
          this.rows = response.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    createPricing() {
      const { id } = this.$route.params;
      this.$router.push({ name: 'create_customer_prices', params: { id } });
    },
    async getPackageTypes() {
      try {
        this.isLoading = true;
        if (this.packagingType && this.packagingType.value === 1) {
          this.packageTypes = await this.getConsignmentPackageType();
          if (this.packageTypes) {
            this.packageType = {
              text: this.packageTypes[0].info,
              value: this.packageTypes[0].value
            };
          }
        } else if (this.packagingType && this.providerType && this.packagingType.value === 2) {
          this.packageTypes = await useService.providerService
            .getProviderPackageTypes(this.providerType.value)
            .then(res => {
              return (res?.data || []).map(i => {
                return {
                  info: i.description,
                  value: i.packagingType
                };
              });
            });
          if (this.packageTypes) {
            this.packageType = {
              text: this.packageTypes[0].info,
              value: this.packageTypes[0].value
            };
          }
        } else {
          this.packageTypes = [];
        }
      } catch (err) {
        this.packageTypes = [];
      } finally {
        this.isLoading = false;
      }
    }
  },
  watch: {
    providerType: {
      handler() {
        this.packageType = '';
        this.getPackageTypes();
      }
    },
    packagingType: {
      handler() {
        this.packageType = '';
        this.getPackageTypes();
      }
    },
    packageType: {
      handler() {
        this.loadItems();
      }
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
